import { render, staticRenderFns } from "./personalGoodsList.vue?vue&type=template&id=2c1bd1b2"
import script from "./personalGoodsList.vue?vue&type=script&lang=js"
export * from "./personalGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports